import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import './resources/modern-main.css';
import './resources/modern-components.css';
import './resources/modern-utilities.css';

/**
 * App component
 * Main application entry point with Router provider and global styles
 */
function App() {
  return (
    <BrowserRouter>
      <div className='app-container'>
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
